import { OutcomeType, DispositionReasonType } from '@/api/apis/case';
import {
  cancelReasonsAborted,
  cancelReasonsDryRun,
  cancelReasonsTurndown,
  specificationNone,
  specificationsCancelledByTmdx,
  specificationsCancelledByTx,
  specificationsTurndownByTx,
} from './config';

export const getCancellationReasons = (declineType: OutcomeType) => {
  switch (declineType) {
    case OutcomeType.Aborted:
      return cancelReasonsAborted;
    case OutcomeType.DryRun:
      return cancelReasonsDryRun;
    case OutcomeType.Turndown:
      return cancelReasonsTurndown;
    default:
      return [];
  }
};

export const getSpecifications = (dispositionReasonType: DispositionReasonType) => {
  switch (dispositionReasonType) {
    case DispositionReasonType.CancelledByTransMedics:
      return specificationsCancelledByTmdx;
    case DispositionReasonType.ByTxCenter:
      return specificationsCancelledByTx;
    case DispositionReasonType.TurndownByTxCenter:
      return specificationsTurndownByTx;
    default:
      return specificationNone;
  }
};
